import React, { Component } from "react";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import PropTypes from "prop-types";

class DeleteContractModal extends Component {
  static propTypes = {
    onConfirmDelete: PropTypes.func.isRequired,
  };

  render() {
    return (
      <ConfirmationModal
        actionDescription="Archive"
        buttonColor="grey"
        onConfirm={this.props.onConfirmDelete}
        menuTrigger={this.props.menuTrigger}
        icon={this.props.noIcon ? null : "trash"}
        warning
      >
        <p>Are you sure you want to archive this contract?</p>
      </ConfirmationModal>
    );
  }
}

export default DeleteContractModal;
